module.exports = __webpack_public_path__ + "img/JDZ-min.622d7eb1.png";